
const permissions = {
	USER_CAN_CREATE:"Create",
	USER_CAN_READ:"Read",
	USER_CAN_UPDATE:"Update",
	USER_CAN_DELETE:"Delete",
	USER_CAN_ANSWER:"Answer"
}

export default  permissions